import React from "react";

const SCULPTURE =
    "https://static.prod-images.emergentagent.com/jobs/c2a6c813-bc74-478b-8bcd-bf9799b402f8/images/c89256b9aeed91319962e3f1ca8b031da19565c93498e4421ede983a9432d6e7.png";
const SILK =
    "https://images.unsplash.com/photo-1760224254181-adac9e1a1900?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85";

export default function About() {
    return (
        <div data-testid="about-page">
            <section
                className="relative overflow-hidden"
                style={{ height: "min(70vh, 640px)" }}
            >
                <img
                    src={SILK}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                    style={{ filter: "brightness(0.55)" }}
                />
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(10,10,11,0.2) 0%, rgba(10,10,11,0.85) 100%)",
                    }}
                />
                <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 h-full flex flex-col justify-end pb-16">
                    <div className="overline mb-4">About Veloura</div>
                    <h1
                        className="font-serif tracking-tight"
                        style={{
                            color: "var(--vl-text)",
                            fontSize: "clamp(40px, 7vw, 104px)",
                            lineHeight: 0.98,
                        }}
                    >
                        An atelier for{" "}
                        <em
                            style={{
                                color: "var(--vl-rose)",
                                fontStyle: "italic",
                            }}
                        >
                            intimate wellness.
                        </em>
                    </h1>
                </div>
            </section>

            <section className="max-w-[900px] mx-auto px-6 md:px-12 py-24 md:py-32">
                <p
                    className="font-serif text-2xl sm:text-3xl tracking-tight"
                    style={{ color: "var(--vl-text)", lineHeight: 1.4 }}
                >
                    We started Veloura because the intimate wellness aisle
                    felt frozen in time — clinical, loud, apologetic. We
                    wanted the opposite: quiet, confident, beautifully made,
                    and genuinely kind to the body.
                </p>
                <p
                    className="mt-8 text-base"
                    style={{
                        color: "var(--vl-muted)",
                        lineHeight: 1.9,
                    }}
                >
                    Every piece we make is dermatologist-reviewed and
                    body-safe. Every formulation is free of glycerin,
                    parabens, fragrance, propylene glycol, and
                    nonoxynol-9. Every mailer is unbranded. Every invoice
                    reads <em>V. Atelier</em>.
                </p>
                <p
                    className="mt-6 text-base"
                    style={{
                        color: "var(--vl-muted)",
                        lineHeight: 1.9,
                    }}
                >
                    Our customers are women, couples, and solo-seekers who
                    already take wellness seriously. They treat sleep as
                    sacred, read their skincare labels, choose their
                    nutrition with care. Veloura belongs in that same
                    vocabulary — without the whispers.
                </p>
            </section>

            <section
                className="relative overflow-hidden"
                style={{
                    background: "var(--vl-surface)",
                    borderTop: "1px solid var(--vl-border)",
                    borderBottom: "1px solid var(--vl-border)",
                }}
            >
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-12 gap-10 items-center">
                    <div className="md:col-span-6">
                        <img
                            src={SCULPTURE}
                            alt="Abstract sculptural piece"
                            className="w-full aspect-[4/5] object-cover"
                        />
                    </div>
                    <div className="md:col-span-6">
                        <div className="overline mb-4">Our standards</div>
                        <h2
                            className="font-serif text-4xl sm:text-5xl tracking-tight"
                            style={{ color: "var(--vl-text)" }}
                        >
                            What we{" "}
                            <em
                                style={{
                                    color: "var(--vl-rose)",
                                    fontStyle: "italic",
                                }}
                            >
                                refuse
                            </em>{" "}
                            to compromise on.
                        </h2>
                        <ul
                            className="mt-8 space-y-5 text-base"
                            style={{ color: "var(--vl-text)" }}
                        >
                            {[
                                "Only medical-grade, body-safe silicone. No porous TPE.",
                                "Every formulation dermatologist-reviewed, always.",
                                "No glycerin. No parabens. No fragrance. No PG. Ever.",
                                "100% discreet, unbranded shipping — always.",
                                "A concierge line on WhatsApp, answered by a human.",
                                "A 14-day return window, no questions asked.",
                            ].map((x) => (
                                <li
                                    key={x}
                                    className="flex items-start gap-4"
                                >
                                    <span
                                        className="mt-3 w-6 h-px flex-shrink-0"
                                        style={{
                                            background: "var(--vl-rose)",
                                        }}
                                    />
                                    <span style={{ lineHeight: 1.7 }}>
                                        {x}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            <section className="max-w-[1200px] mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
                <div className="overline mb-4">A quiet promise</div>
                <p
                    className="font-serif text-3xl sm:text-5xl tracking-tight max-w-3xl mx-auto"
                    style={{ color: "var(--vl-text)", lineHeight: 1.2 }}
                >
                    Intimate wellness should feel like{" "}
                    <em
                        style={{
                            color: "var(--vl-rose)",
                            fontStyle: "italic",
                        }}
                    >
                        skincare, sleep, and a good meal —
                    </em>{" "}
                    not a secret.
                </p>
            </section>
        </div>
    );
}
